module.exports = "pegasus_template/assets/tech/small/3.jpg";